import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Select,
    Table,
    Tag,
    Radio,
    Tabs,
    Badge, Popconfirm, Modal
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";

const {Title, Text} = Typography;
const {Content} = Layout;
const {RangePicker} = DatePicker;
const { TabPane } = Tabs;
const Go = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            function queryParse(query){
                let queryText = "";
                for(let key in query){
                    queryText += `${key}=${query[key]}&`;
                }
                return queryText.slice(0,-1);
            }
            var list = {};
            list.fund_value = id.value ? id.value : 0;
            list.fund_type = 1;
            list.fund_intro = id.date + '结算';
            list.fund_client = id.id;
            list.fund_admin = id.admin ? id.admin : 1;

            fetch("https://pd.pokemonbye.com:8084/api/insertsellfund",
                {
                    method:'post',
                    body:queryParse(list),
                    headers:{
                        'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        //window.location.href="/pagebuscontracts"
                        window.location.reload();
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Popconfirm
            title="确认扎账？扎账后无法撤回。"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button type="primary" onClick={showPopconfirm}>
                结算
            </Button>
        </Popconfirm>
    );
};
const onGo = (id,date) => {
    window.location.href="/pagefinsetsprice?id=" + id + "&date=" + date
};
const App = (value) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState('查询中');
    const [content2, setContent2] = useState('');
    const [content3, setContent3] = useState('');
    const showModal = () => {
        setIsModalOpen(true);
        console.log(value)
        setTimeout(() => {

            fetch("https://pd.pokemonbye.com:8084/api/getsellfundsumbyclientdate?id=" + value.id + "&date=" + value.month)
                .then(res => res.json())
                .then(
                    (result) => {
                        console.log(result)
                        if(result.data!=null&&result.data.length>0&&result.data[0].fund_sum!=null){

                            setContent("单位："+result.data[0].client_name)
                            setContent2("账期："+value.month.substring(0,7))
                            setContent3("余额："+result.data[0].fund_sum+'元')
                        }else{

                            setContent('无记录')
                        }
                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <Button type="primary" onClick={showModal}>
                余额
            </Button>
            <Modal title="结算余额" open={isModalOpen}
                   footer={[
                       <Button key="back" onClick={handleCancel}>
                           关闭
                       </Button>
                   ]}>
                <p>{content}</p>
                <p>{content2}</p>
                <p>{content3}</p>
            </Modal>
        </>
    );
};
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '账期',
        dataIndex: 'fund_date',
        key: 'fund_date',
        render: (fund_date) => <p>{fund_date ? fund_date.substring(0,7) : ''}</p>,
    },
    {
        title: '单位',
        dataIndex: 'fund_client',
        key: 'fund_client',
    },
    {
        title: '采购量（吨）',
        dataIndex: 'fund_num',
        key: 'fund_num',
    },
    {
        title: '采购金额（元）',
        dataIndex: 'fund_value',
        key: 'fund_value',
    },
    {
        title: '结算时间',
        dataIndex: 'fund_pubtime',
        key: 'fund_pubtime',
        render: (fund_pubtime) => <p>{fund_pubtime ? fund_pubtime.substring(0,19) : '0.00'}</p>,
    },
    {
        title: '功能',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <App type="primary" id={record.fund_clientname} month={record.fund_date}></App>
                <Button type="primary" onClick={()=>onGo(record.fund_id,record.fund_date)}>改价</Button>
            </Space>
        ),
    },
];

const Load = (that,month) => {

    var month = month+'-26'
    fetch("https://pd.pokemonbye.com:8084/api/getsellfundlikeintrobydate?intro=%E7%BB%93%E7%AE%97&month="+ month)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1;
                    }
                    that.setState({
                        isLoaded: true,
                        list: array
                    });
                }
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Load2 = (that,value,month) => {
    var month = month+'-26'
    fetch("https://pd.pokemonbye.com:8084/api/getsellfundlikeintrobyclient?intro=%E7%BB%93%E7%AE%97&client=" + value + "&month=" + month)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1;
                    }
                }
                that.setState({
                    isLoaded: true,
                    list: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

class PageFinSetsHis extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const userId = cookie.load('userId');
        this.state = {
            title: "扎账历史",
            county: [],
            id: id,
            list: [],
            userid: userId,
            listman: [],
            listcus: [],
            options: [],
            selid: 1,
            islocked: '',
            sum: [],
            max: 0,
            month: moment().format('YYYY-MM')
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellclient")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].value = array[i].id;
                            array[i].label = array[i].name;
                        }
                        this.setState({
                            isLoaded: true,
                            options: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        Load(this,this.state.month);

    }

    render() {
        const handleChange = (value) => {
            this.setState({
                client: value
            });
            Load2(this,value,this.state.month);
        };
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: (record) => ({
                disabled: record.name === 'Disabled User',
                // Column configuration not to be checked
                name: record.name,
            }),
        };
        const onChange = (date, dateString) => {
            console.log(dateString);
            this.setState({
                month: dateString
            });
            if(this.state.client){

                Load2(this,this.state.client,dateString);
            }else{

                Load(this,dateString);
            }
        };
        const onClick = () => {
            var month = this.state.month + '-26'
            fetch("https://pd.pokemonbye.com:8084/api/getsellfundbydateexcel?intro=%E7%BB%93%E7%AE%97&month="+ month)
                .then(res => res.json())
                .then(
                    (result) => {
                        console.log("https://pd.pokemonbye.com:8084/api/getsellfundbydateexcel?intro=%E7%BB%93%E7%AE%97&month="+ month)
                        console.log(result)
                        let array = result.data;
                        if(array!=null&&array.length>0){
                            window.open(array[0]);
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {

                    }
                )
        };
        return (
            <div>
                <Leftmenu/>
                <div className="mainpanel">
                    <Header/>
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            ><Space>

                                <Select
                                    defaultValue="请选择"
                                    style={{
                                        width: 220,
                                    }}
                                    onChange={handleChange}
                                    options={this.state.options}
                                />
                                <DatePicker defaultValue={moment} onChange={onChange} picker="month"/>
                                <Button type="primary" onClick={onClick}>下载</Button>
                            </Space>
                                <br/>
                                <br/>
                                <Table bordered={true} columns={columns} dataSource={this.state.list}/>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageFinSetsHis;


